"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.json.stringify.js");
var _default2 = exports.default = {
  props: {
    loading: {
      type: Boolean
    },
    /* 查询数组 */
    query: {
      type: Array,
      default: function _default() {
        return [];
      },
      validator: function validator(v) {
        if (Array.isArray(v)) {
          // const codes = {}
          for (var i = 0; i < v.length; i++) {
            var _item$value;
            var item = v[i];
            var s1 = "\n\u9519\u8BEF\uFF1A\n".concat(JSON.stringify(item));
            var s2 = "\n\u53C2\u8003\uFF1A\n{ label: '\u67E5\u8BE2\u6761\u4EF6\u4E00', code: 'xxx1' },\n{ label: '\u67E5\u8BE2\u6761\u4EF6\u4E8C', code: 'xxx2' },\n ...";
            // if (!item.label) {
            //   // eslint-disable-next-line no-console
            //   console.error(`wl-drawer-search 组件:\n query 中缺少 label 参数${s1}${s2}`)
            //   return []
            // }
            if (!item.code) {
              // eslint-disable-next-line no-console
              console.error("wl-drawer-search \u7EC4\u4EF6:\n query \u4E2D\u7F3A\u5C11 code \u53C2\u6570".concat(s1).concat(s2));
              return [];
            }

            // codes[item.code] ??= 0
            // codes[item.code]++
            // if (codes[item.code] >= 2) {
            //   // eslint-disable-next-line no-console
            //   console.error(`wl-drawer-search 组件:\n query 中 code 参数必须唯一`)
            //   return []
            // }

            (_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : item.value = '';
          }
          return true;
        } else {
          // eslint-disable-next-line no-console
          console.error("wl-drawer-search \u7EC4\u4EF6:\n query \u53C2\u6570\u5FC5\u987B\u4E3A\u6570\u7EC4]\n\u53C2\u8003\uFF1A\n[\n\t{ label: '\u67E5\u8BE2\u6761\u4EF6\u4E00', code: 'xxx1' },\n\t{ label: '\u67E5\u8BE2\u6761\u4EF6\u4E8C', code: 'xxx2' },\n\t ...\n]");
          return false;
        }
      }
    },
    queryValue: {
      type: String,
      default: ''
    }
  }
};